"use strict";

module.exports = function (input) {
  return input.replace(/s'(\s|$)/gim, "s’$1");
};

